<template>
  <div class="info-block">
    <label class="info-label">{{ label }}</label>
    <div class="info-value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['label'],
};
</script>

<style lang="scss" scoped>
.info-block {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.info-label {
  font-weight: 600;
  color: #64756c;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.info-value {
  padding: 0.9rem 1rem;
  border: 1px solid rgba(28, 68, 38, 0.08);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  color: #203026;
}
</style>
